<template>
  <Modal
    v-model="_value"
    width="700"
    title="批量增加下发指令"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <Form ref="sendCmdRef" v-model="sendCmd">
      <Form-item label="生产厂商">
        <Select v-model="batchManufacturer" @on-change="getManufacturer">
          <Option value='请选择' key=0>请选择</Option>
          <Option value='惠州博实结科技有限公司' key=1>惠州博实结科技有限公司</Option>
          <Option value='杭州海康汽车技术有限公司' key=2>杭州海康汽车技术有限公司</Option>
          <Option value='易流' key=3>易流</Option>
          <Option value='有为' key=4>有为</Option>
          <Option value='深圳市锐明技术股份有限公司' key=5>深圳市锐明技术股份有限公司</Option>
          <Option value='江苏中天安驰科技有限公司' key=6>江苏中天安驰科技有限公司</Option>
        </Select>
      </Form-item>
      <FormItem prop="terminalNums" label="主机号/终端号">
        <Input type="textarea" v-model="sendCmd.terminalNums" placeholder="主机号/终端号：“,”间隔">
        </Input>
      </FormItem>
      <FormItem prop="automaticSending" label="是否设备上线自动下发">
        <Checkbox v-model="sendCmd.automaticSending"></Checkbox>
      </FormItem>
      <FormItem prop="timedTransmission" label="是否定时下发">
        <Checkbox v-model="sendCmd.timedTransmission"></Checkbox>
      </FormItem>
      <FormItem prop="intervalTime" label="定时下发间隔时间">
        <Select :disabled="!sendCmd.timedTransmission" v-model="sendCmd.intervalTime" style="width: 220px;">
          <Option v-for="item in timedTransmissionOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="cmdList" label="指令列表">
        <Input v-model="sendCmd.firstcmd" placeholder="请输入指令">
        </Input>
        <Input :disabled="sendCmd.firstcmd==null || sendCmd.firstcmd==''" v-model="sendCmd.secondcmd" placeholder="请输入指令">
        </Input>
        <Input :disabled="sendCmd.firstcmd==null || sendCmd.firstcmd=='' || sendCmd.secondcmd==null || sendCmd.secondcmd==''" v-model="sendCmd.thirdcmd" placeholder="请输入指令">
        </Input>
        <Input :disabled="sendCmd.firstcmd==null || sendCmd.firstcmd=='' || sendCmd.secondcmd==null || sendCmd.secondcmd==''" v-model="sendCmd.fourthcmd" placeholder="请输入指令">
        </Input>
        <Input :disabled="sendCmd.firstcmd==null || sendCmd.firstcmd=='' || sendCmd.secondcmd==null || sendCmd.secondcmd==''" v-model="sendCmd.fifthcmd" placeholder="请输入指令">
        </Input>
        <Input :disabled="sendCmd.firstcmd==null || sendCmd.firstcmd=='' || sendCmd.secondcmd==null || sendCmd.secondcmd==''" v-model="sendCmd.sixthcmd" placeholder="请输入指令">
        </Input>
      </FormItem>
      <Form-item label="指令">
        <Dropdown style="margin-right: 5px;">
          <Button type="primary">
            海康
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <!--              <DropdownItem>采集信息</DropdownItem>-->
            <!--              <DropdownItem>写卡</DropdownItem>-->
            <!--              <DropdownItem>设置车牌号</DropdownItem>-->
            <!--              <DropdownItem>设置车辆参数</DropdownItem>-->
            <DropdownItem @click.native="hikTravelTimeModal = true">设置夜间行驶时长</DropdownItem>
            <!--              <DropdownItem>采集设备信息</DropdownItem>-->
            <!--              <DropdownItem>获取设备报警</DropdownItem>-->
          </DropdownMenu>
        </Dropdown>
        <Dropdown style="margin-right: 5px;">
          <Button type="primary">
            锐明
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <!--              <DropdownItem>采集信息</DropdownItem>-->
            <!--              <DropdownItem>写卡</DropdownItem>-->
            <!--              <DropdownItem>设置车辆参数</DropdownItem>-->
            <!--              <DropdownItem>设置参数</DropdownItem>-->
            <DropdownItem @click.native="rmDriverModal = true">设置协议</DropdownItem>
            <DropdownItem @click.native="rmDriverAlarmConditionModal = true">设置报警触发</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Dropdown style="margin-right: 5px;">
          <Button type="primary">
            中天
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <!--              <DropdownItem>采集信息</DropdownItem>-->
            <!--              <DropdownItem>写卡</DropdownItem>-->
            <!--              <DropdownItem>设置车辆参数</DropdownItem>-->
            <DropdownItem @click.native="ztDriverSpeedAlarmModal = true">设置速度报警</DropdownItem>
            <!--              <DropdownItem>设置里程</DropdownItem>-->
            <DropdownItem @click.native="ztDriverRestartModal = true">重启控制</DropdownItem>
            <!--              <DropdownItem>磁盘格式化</DropdownItem>-->
            <DropdownItem @click.native="ztDriverCenternetworkModal = true">设置IP</DropdownItem>
            <DropdownItem @click.native="ztDriverAdasAlarmModal = true">ADAS报警</DropdownItem>
            <DropdownItem @click.native="ztDriverDsmAlarmModal = true">DSM报警</DropdownItem>
            <DropdownItem @click.native="ztDriverAlarmEnablelModal = true">报警使能</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Form-item>
      <Form-item label="指令内容">
        <Input type="textarea" v-model="cmd" placeholder="指令内容"></Input>
      </Form-item>
    </Form>
    <hik-travel-time-modal v-model="hikTravelTimeModal" :initValue="hikTravelTimeId" @HIK_TravelTime="HIK_TravelTime"></hik-travel-time-modal>
    <rm-driver-modal v-model="rmDriverModal" :initValue="rmDriverId" @RM_Driver="RM_Driver"></rm-driver-modal>
    <rm-driver-alarm-condition-modal v-model="rmDriverAlarmConditionModal" :initValue="rmDriverAlarmConditionId" @Rm_Driver_Alarm_Condition="Rm_Driver_Alarm_Condition"></rm-driver-alarm-condition-modal>
    <zt-driver-speed-alarm-modal v-model="ztDriverSpeedAlarmModal" :initValue="ztDriverSpeedAlarmId" @ZT_DriverSpeedAlarm="ZT_DriverSpeedAlarm"></zt-driver-speed-alarm-modal>
    <zt-driver-restart-modal v-model="ztDriverRestartModal" :initValue="ztDriverRestartId" @ZT_DriverRestart="ZT_DriverRestart"></zt-driver-restart-modal>
    <zt-driver-centernetwork-modal v-model="ztDriverCenternetworkModal" :initValue="ztDriverCenternetworkId" @ZT_DriverCenternetwork="ZT_DriverCenternetwork"></zt-driver-centernetwork-modal>
    <zt-driver-adas-alarm-modal v-model="ztDriverAdasAlarmModal" :initValue="ztDriverAdasAlarmId" @ZT_DriverAdasAlarm="ZT_DriverAdasAlarm"></zt-driver-adas-alarm-modal>
    <zt-driver-dsm-alarm-modal v-model="ztDriverDsmAlarmModal" :initValue="ztDriverDsmAlarmId" @ZT_DriverDsmAlarm="ZT_DriverDsmAlarm"></zt-driver-dsm-alarm-modal>
    <zt-driver-alarm-enablel-modal v-model="ztDriverAlarmEnablelModal" :initValue="ztDriverAlarmEnablelId" @ZT_DriverAlarmEnablel="ZT_DriverAlarmEnablel"></zt-driver-alarm-enablel-modal>

  </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

import HikTravelTimeModal from '@/view/ddm/components/hik-travel-time-modal'
import RmDriverModal from '@/view/ddm/components/rm-driver-modal'
import RmDriverAlarmConditionModal from '@/view/ddm/components/rm-driver-alarm-condition-modal'
import ZtDriverSpeedAlarmModal from '@/view/ddm/components/zt-driver-speed-alarm-modal'
import ZtDriverRestartModal from '@/view/ddm/components/zt-driver-restart-modal'
import ZtDriverCenternetworkModal from '@/view/ddm/components/zt-driver-centernetwork-modal'
import ZtDriverAdasAlarmModal from '@/view/ddm/components/zt-driver-adas-alarm-modal'
import ZtDriverDsmAlarmModal from '@/view/ddm/components/zt-driver-dsm-alarm-modal'
import ZtDriverAlarmEnablelModal from '@/view/ddm/components/zt-driver-alarm-enablel-modal'

export default {
  name: 'jt808batchaddsengcmdmodal',
  components: {
    HikTravelTimeModal,
    RmDriverModal,
    RmDriverAlarmConditionModal,
    ZtDriverSpeedAlarmModal,
    ZtDriverRestartModal,
    ZtDriverCenternetworkModal,
    ZtDriverAdasAlarmModal,
    ZtDriverDsmAlarmModal,
    ZtDriverAlarmEnablelModal,

  },
  props: {
    initValue: null,
    terminalNumsValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      sendCmd: {
        terminalNums: [],
        automaticSending: false,
        timedTransmission: false,
        intervalTime: 0,
        firstcmd: null,
        secondcmd: null,
        thirdcmd: null,
        fourthcmd: null,
        fifthcmd: null,
        sixthcmd: null,
      },

      timedTransmissionOptions:[
        {name: '30秒', value: 30},
        {name: '5分钟', value: 300},
        {name: '15分钟', value: 900},
        {name: '1小时', value: 3600},
      ],

      cmd:null,

      // Hik批量设置设置夜间行驶时长
      hikTravelTimeModal: false,
      hikTravelTimeId: null,

      // 锐明批量设置车辆协议
      rmDriverModal:false,
      rmDriverId:null,

      rmDriverAlarmConditionModal:false,
      rmDriverAlarmConditionId:null,

      // 中天安驰批量设置速度报警
      ztDriverSpeedAlarmModal: false,
      ztDriverSpeedAlarmId: null,

      // 中天安驰批量重启控制
      ztDriverRestartModal: false,
      ztDriverRestartId: null,

      // 中天安驰设置IP
      ztDriverCenternetworkModal:false,
      ztDriverCenternetworkId:null,

      //中天安驰pi设置ADAS报警
      ztDriverAdasAlarmModal:false,
      ztDriverAdasAlarmId:null,

      //中天安驰批量设置DSM报警
      ztDriverDsmAlarmModal:false,
      ztDriverDsmAlarmId:null,

      //中天安驰批量设置报警使能
      ztDriverAlarmEnablelModal:false,
      ztDriverAlarmEnablelId:null,
    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    onOk(){
      if (this.sendCmd.terminalNums instanceof Array){

      } else {
        this.sendCmd.terminalNums = this.sendCmd.terminalNums.split(',')
      }
      console.log(this.sendCmd.intervalTime)
      store.dispatch('SendCmdServ_BatchAddObj',{
        params:this.sendCmd,
        urlparams:null
      }).then(res => {
        console.log(res)
        this.$emit('on-success')
      }).catch(err => {
        console.log(err)
        this.$Message.error(err)
      })
    },
    visibleChange (val) {
      if (val) {
        // this.sendCmd.terminalNums = []
        this.sendCmd.automaticSending = false
        this.sendCmd.timedTransmission = false
        this.sendCmd.intervalTime = 0
        this.sendCmd.intervalTime = null
        this.sendCmd.firstcmd = null
        this.sendCmd.secondcmd = null
        this.sendCmd.thirdcmd = null
        this.sendCmd.fourthcmd = null
        this.sendCmd.fifthcmd = null
        this.sendCmd.sixthcmd = null

      }
    },

    getManufacturer(e){
      console.log(e)
      if (e!='请选择') {
        // this.terminalNums = null
        this.sendCmd.terminalNums = []
        store.dispatch('PositioningDeviceInfoServ_GetTerminalnumForManufacturer', {
          params: {
            manufacturer: e
          },
          urlparams: {},
        }).then(res => {
          console.log(res)
          // store.getters.get_PositioningDeviceInfo_GetTerminalnumForManufacturerResult
          // this.sendCmd.terminalNums = []
          store.getters.get_PositioningDeviceInfo_GetTerminalnumForManufacturerResult.forEach(item => {
            this.sendCmd.terminalNums.push(item.terminalNum)
          })

          // this.terminalNums = this.sendCmd.terminalNums.toString()

        }).catch(err => {
          console.log(err)
        })
      }else {
        // this.terminalNums = null
        this.sendCmd.terminalNums = []
      }
    },

    HIK_TravelTime(batchSendCmd){
      this.cmd = batchSendCmd.cmd
      this.hikTravelTimeModal = false
    },

    RM_Driver(batchSendCmd){
      this.cmd = batchSendCmd.cmd
      this.rmDriverModal = false
    },

    Rm_Driver_Alarm_Condition(batchSendCmd){
      this.cmd = batchSendCmd.cmd
      this.rmDriverAlarmConditionModal = false
    },

    ZT_DriverSpeedAlarm(batchSendCmd){
      this.cmd = batchSendCmd.cmd
      this.ztDriverSpeedAlarmModal = false
    },

    ZT_DriverRestart(batchSendCmd){
      this.cmd = batchSendCmd.cmd
      this.ztDriverRestartModal = false
    },

    ZT_DriverCenternetwork(batchSendCmd){
      this.cmd = batchSendCmd.cmd
      this.ztDriverCenternetworkModal = false
    },

    ZT_DriverAdasAlarm(batchSendCmd){
      this.cmd = batchSendCmd.cmd
      this.ztDriverAdasAlarmModal = false
    },

    ZT_DriverDsmAlarm(batchSendCmd){
      this.cmd = batchSendCmd.cmd
      this.ztDriverDsmAlarmModal = false
    },

    ZT_DriverAlarmEnablel(batchSendCmd){
      this.cmd = batchSendCmd.cmd
      this.ztDriverAlarmEnablelModal = false
    },
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumsValue: {
      get () {
        return this.terminalNumsValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
